import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Funcionario } from './funcionario'

export type DescontoDSRFuncionario = z.infer<typeof zod.DescontoDsrSchema> & {
    Funcionario: Funcionario
}

export type DescontoDSREmpresas = {
    id: string
    Funcionario: Funcionario
    valor: string
    detalhes: Omit<DescontoDSRFuncionario, 'Funcionario' | 'id'>[]
}

export const descontoDsr = new ApiService<
    DescontoDSRFuncionario | DescontoDSREmpresas
>('desconto-dsr')
